/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useContext, useEffect, useState } from 'react';
import { Accordion, Card, Col, Row, Table } from 'react-bootstrap';
import Axios from 'axios';
import InputControlAsync from '../../../components/inputs/InputControlAsync';
import TabelWrokDay from './porfileWorker/TabelWrokDay';
import DocumentWorker from './porfileWorker/DocumentWorker';
import OrderWorker from './orderWorker';
import FinanceWorker from './finance';
import LevelWorker from './porfileWorker/LevelWorker';
import DashboardContext from '../../../Context';
import Layout from '../../../components/layout';
import { Redirect, useHistory } from 'react-router-dom';
import WorkerMessages from './workerMessages';
import Introducers from './introducers';
import DefaultWorkerAddress from './porfileWorker/DefaultWorkerAddress';
import WorkerBlacklist from './workerBlacklist';
import WorkerFavlist from './workerFavlist';
import SurveyWorker from './surveyWorker';
import JobDispatchWorker from './jobDispatchWorker';
import ExpertTicket from '../expertTicket';

const WorkerId = ({ match }) => {
  const {
    islogin,
    authentication,
    urldashboard,
    idview,
    handeldmicro,
    handelIdview,
    handelworkername,
    handelAdd,
    handelEdit,
    handelloding,
    handelerrors,
    walletupdate,
  } = useContext(DashboardContext);

  const [idAccordion, setIdAccordion] = useState();
  const [dataFech, setDataFech] = useState({});
  const [navitem, setNavitem] = useState('امور مالی');
  const [loading, setLoading] = useState(true);

  const [id, setId] = useState(match.params.id);
  if (id !== match.params.id) setId(match.params.id);

  const history = useHistory();

  let phoneNumberPath = history.location.pathname.split('/')[2];

  if (phoneNumberPath.startsWith(98)) {
    phoneNumberPath = phoneNumberPath.substr(2);
  }

  if (phoneNumberPath.startsWith(0)) {
    phoneNumberPath = phoneNumberPath.substr(1);
  }

  if (phoneNumberPath !== undefined && phoneNumberPath.length === 10) {
    Axios.get(`${urldashboard}/worker/GetByPhoneNumber/${phoneNumberPath}`, {
      headers: {
        Authorization: authentication,
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        const data = res.data.data;

        if (data !== undefined) {
          handelworkername(data.fullName);
          setDataFech(data);
          setId(data.userId);
          sessionStorage.setItem('workerId', JSON.stringify(data.userId));
          setLoading(false);
        } else {
          return;
        }
      })
      .catch(() => {
        Axios.get(
          `${urldashboard}/customer/GetByPhoneNumber/${phoneNumberPath}`,
          {
            headers: {
              Authorization: authentication,
              'Content-Type': 'application/json',
            },
          }
        )
          .then((customer) => {
            if (customer.data.data.id !== undefined) {
              history.push(`/Customer/${customer.data.data.id}`);
            }
          })
          .catch(() => {});
      });
  }

  const dataFeching = async () => {
    try {
      const res = await Axios.get(
        `${urldashboard}/worker/get/${match.params.id}`,
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await res.data.data;
      handelworkername(data.fullName);
      setDataFech(data);
      setLoading(false);
    } catch (error) {
      handelerrors(error);
    }
  };

  useEffect(() => {
    if (phoneNumberPath.length !== 10) {
      dataFeching();
      sessionStorage.setItem('workerId', JSON.stringify(match.params.id));
    } else {
    }

    return () => {};
  }, [idview, match.params.id, walletupdate]);

  const handelnavLink = (id) => {
    switch (id) {
      case 'اطلاعات شخصی':
        setNavitem('اطلاعات شخصی');
        break;
      case 'امور مالی':
        setNavitem('امور مالی');
        break;
      case 'کارهای نیرو':
        setNavitem('کارهای نیرو');
        break;
      case 'پخش کار':
        setNavitem('پخش کار');
        break;
      case 'پیام‌ها':
        setNavitem('پیام‌ها');
        break;
      case 'لیست سیاه':
        setNavitem('لیست سیاه');
        break;
      case 'مورد علاقه':
        setNavitem('مورد علاقه');
        break;
      case 'معرف‌ها':
        setNavitem('معرف‌ها');
        break;
      case 'نظرسنجی':
        setNavitem('نظرسنجی');
        break;
      case 'تیکتها':
        setNavitem('تیکتها');
        break;
      default:
        break;
    }
    defaultAcionts();
  };

  const handelAccordion = (id) => {
    setIdAccordion(id);
    defaultAcionts();
  };

  const defaultAcionts = () => {
    handeldmicro(false);
    sessionStorage.setItem('startpageProps', JSON.stringify(1));
    sessionStorage.setItem('serchProps', JSON.stringify(''));
    sessionStorage.setItem('pageSizeProps', JSON.stringify(10));
    sessionStorage.setItem('PaginationProps', JSON.stringify([]));
  };

  const handelEditbtn = (id) => {
    handelAdd(true);
    handelEdit(id);
    handelloding(true);
  };

  const handelValue = (name, value) => {
    if (value) {
      setLoading(true);
      sessionStorage.setItem('workerId', value);
      history.push(`/Worker/${value}`);
      // dataFeching()
      // handelIdview(value)
      handelnavLink('امور مالی');
    }
  };

  return (
    <>
      {islogin ? (
        <Layout>
          <section
            section
            style={{ backgroundColor: 'white', padding: '20px' }}
          >
            <Row>
              <Col>
                <InputControlAsync
                  url='/worker/search'
                  label='انتخاب نیرو'
                  name='customer'
                  handelValue={handelValue}
                />
              </Col>
            </Row>
            {!loading ? (
              <Row>
                <Col>
                  <nav class='nav nav-pills' role='tablist'>
                    <a
                      id='noanim-tab-example-tab-home'
                      href='#'
                      role='tab'
                      data-rb-event-key='home'
                      aria-controls='noanim-tab-example-tabpane-home'
                      aria-selected='false'
                      className={
                        navitem === 'اطلاعات شخصی'
                          ? 'nav-item nav-link active'
                          : 'nav-item nav-link'
                      }
                      tabindex='-1'
                      onClick={() => handelnavLink('اطلاعات شخصی')}
                    >
                      اطلاعات شخصی
                    </a>
                    <a
                      id='noanim-tab-example-tab-finance'
                      href='#'
                      role='tab'
                      data-rb-event-key='finance'
                      aria-controls='noanim-tab-example-tabpane-finance'
                      aria-selected='false'
                      className={
                        navitem === 'امور مالی'
                          ? 'nav-item nav-link active'
                          : 'nav-item nav-link'
                      }
                      tabindex='-1'
                      onClick={() => handelnavLink('امور مالی')}
                    >
                      امور مالی
                    </a>
                    <a
                      id='noanim-tab-example-tab-order'
                      href='#'
                      role='tab'
                      data-rb-event-key='order'
                      aria-controls='noanim-tab-example-tabpane-order'
                      aria-selected='true'
                      className={
                        navitem === 'کارهای نیرو'
                          ? 'nav-item nav-link active'
                          : 'nav-item nav-link'
                      }
                      onClick={() => handelnavLink('کارهای نیرو')}
                    >
                      کارهای نیرو
                    </a>
                    <a
                      id='noanim-tab-example-tab-jobDispatch'
                      href='#'
                      role='tab'
                      data-rb-event-key='jobDispatch'
                      aria-controls='noanim-tab-example-tabpane-jobDispatch'
                      aria-selected='true'
                      className={
                        navitem === 'پخش کار'
                          ? 'nav-item nav-link active'
                          : 'nav-item nav-link'
                      }
                      onClick={() => handelnavLink('پخش کار')}
                    >
                      پخش کار
                    </a>
                    <a
                      id='noanim-tab-example-tab-message'
                      href='#'
                      role='tab'
                      data-rb-event-key='message'
                      aria-controls='noanim-tab-example-tabpane-message'
                      aria-selected='true'
                      className={
                        navitem === 'پیام‌ها'
                          ? 'nav-item nav-link active'
                          : 'nav-item nav-link'
                      }
                      onClick={() => handelnavLink('پیام‌ها')}
                    >
                      پیام‌ها
                    </a>
                    <a
                      id='noanim-tab-example-tab-blacklist'
                      href='#'
                      role='tab'
                      data-rb-event-key='blacklist'
                      aria-controls='noanim-tab-example-tabpane-blacklist'
                      aria-selected='true'
                      className={
                        navitem === 'لیست سیاه'
                          ? 'nav-item nav-link active'
                          : 'nav-item nav-link'
                      }
                      onClick={() => handelnavLink('لیست سیاه')}
                    >
                      لیست سیاه
                    </a>
                    <a
                      id='noanim-tab-example-tab-favlist'
                      href='#'
                      role='tab'
                      data-rb-event-key='favlist'
                      aria-controls='noanim-tab-example-tabpane-favlist'
                      aria-selected='true'
                      className={
                        navitem === 'مورد علاقه'
                          ? 'nav-item nav-link active'
                          : 'nav-item nav-link'
                      }
                      onClick={() => handelnavLink('مورد علاقه')}
                    >
                      مورد علاقه
                    </a>
                    <a
                      id='noanim-tab-example-tab-intro'
                      href='#'
                      role='tab'
                      data-rb-event-key='intro'
                      aria-controls='noanim-tab-example-tabpane-intro'
                      aria-selected='true'
                      className={
                        navitem === 'معرف‌ها'
                          ? 'nav-item nav-link active'
                          : 'nav-item nav-link'
                      }
                      onClick={() => handelnavLink('معرف‌ها')}
                    >
                      معرف‌ها
                    </a>
                    <a
                      id='noanim-tab-example-tab-survey'
                      href='#'
                      role='tab'
                      data-rb-event-key='survey'
                      aria-controls='noanim-tab-example-tabpane-survey'
                      aria-selected='true'
                      className={
                        navitem === 'نظرسنجی'
                          ? 'nav-item nav-link active'
                          : 'nav-item nav-link'
                      }
                      onClick={() => handelnavLink('نظرسنجی')}
                    >
                      نظرسنجی
                    </a>
                    <a
                      id='noanim-tab-example-tab-ticket'
                      href='#'
                      role='tab'
                      data-rb-event-key='ticket'
                      aria-controls='noanim-tab-example-tabpane-ticket'
                      aria-selected='true'
                      className={
                        navitem === 'تیکتها'
                          ? 'nav-item nav-link active'
                          : 'nav-item nav-link'
                      }
                      onClick={() => handelnavLink('تیکتها')}
                    >
                      تیکتها
                    </a>
                  </nav>
                  <div className='tab-content' id='pills-tabContent'>
                    <div
                      className='tab-pane fade active show'
                      id='pills-home'
                      role='tabpanel'
                      aria-labelledby='pills-home-tab'
                    >
                      {navitem === 'اطلاعات شخصی' ? (
                        <div>
                          <Row>
                            <Col lg='6' md='6' sm='6' xs='12'>
                              <div
                                style={{
                                  border: '1px solid #e9e9e9',
                                  borderRadius: '10px',
                                }}
                              >
                                <div className='d-flex'>
                                  <img
                                    src={
                                      dataFech.pictureUrl
                                        ? dataFech.pictureUrl
                                        : 'https://via.placeholder.com/100x100'
                                    }
                                    alt=''
                                    width='100'
                                    height='100'
                                    className='imge_Profile lazy'
                                    loading='lazy'
                                  />
                                  <div className='mt-3 mr-4'>
                                    <p className='text-nowrap'>
                                      {dataFech.fullName}
                                    </p>
                                    <p className='text-nowrap'>
                                      <i
                                        style={{ fontSize: '18px' }}
                                        className='mdi mdi-cellphone-basic ml-2'
                                      ></i>
                                      {dataFech.cellPhone}
                                    </p>
                                    <p className='text-nowrap'>
                                      {' '}
                                      <i className='mdi mdi-account-card-details ml-2'></i>
                                      {dataFech.nationalCode}{' '}
                                    </p>
                                  </div>
                                  <button
                                    style={{ height: '35px' }}
                                    onClick={() => handelEditbtn(idview)}
                                    className=' mr-auto mt-5 btn btn-sm btn-outline-warning btn-fw'
                                  >
                                    ویرایش
                                  </button>
                                </div>

                                <Table
                                  hover
                                  className='tabele_Worker-profile_info'
                                >
                                  <tbody>
                                    <tr>
                                      <td className='text-nowrap'>
                                        امتیاز نیرو
                                      </td>
                                      <td>{dataFech.points}</td>
                                    </tr>
                                    <tr>
                                      <td className='text-nowrap'>نوع نیرو</td>
                                      <td>{dataFech.workerTypeTitle}</td>
                                    </tr>
                                    <tr>
                                      <td className='text-nowrap'>
                                        {' '}
                                        وضعیت تعهد
                                      </td>
                                      <td>
                                        {dataFech.committedTypeTitle ?? '-'}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className='text-nowrap'>
                                        سیستم عامل{' '}
                                        <i className='mdi mdi-android mr-2'></i>
                                      </td>
                                      <td>{dataFech.mobileTypeTitle}</td>
                                    </tr>
                                    <tr>
                                      <td className='text-nowrap'>
                                        شماره شبا{' '}
                                      </td>
                                      <td>IR-{dataFech.shebaCode}</td>
                                    </tr>
                                    <tr>
                                      <td className='text-nowrap'>
                                        شماره کارت{' '}
                                        <i className='mdi mdi-credit-card'></i>
                                      </td>
                                      <td>{dataFech.debitCardNumber} </td>
                                    </tr>
                                    <tr>
                                      <td className='text-nowrap'>
                                        اعتبار کیف پول
                                        <i className=' mr-1 mdi mdi-wallet'></i>
                                      </td>
                                      <td>
                                        {new Intl.NumberFormat('ja-JP', {
                                          maximumSignificantDigits: 12,
                                        }).format(dataFech.walletAmount)}{' '}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className='text-nowrap'>
                                        مبلغ بدهی
                                        <i className=' mr-1 mdi mdi-database-minus'></i>
                                      </td>
                                      <td>
                                        {new Intl.NumberFormat('ja-JP', {
                                          maximumSignificantDigits: 12,
                                        }).format(dataFech.debtAmount)}{' '}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className='text-nowrap'>
                                        مابه‌التفاوت حساب
                                        <i className=' mr-1 mdi mdi-database'></i>
                                      </td>
                                      <td style={{ fontSize: '20px' }}>
                                        {dataFech.differenceAmount > 0 ? (
                                          new Intl.NumberFormat('ja-JP', {
                                            maximumSignificantDigits: 12,
                                          }).format(dataFech.differenceAmount)
                                        ) : (
                                          <span style={{ color: 'red' }}>
                                            {new Intl.NumberFormat('ja-JP', {
                                              maximumSignificantDigits: 12,
                                            }).format(
                                              dataFech.differenceAmount
                                            )}
                                          </span>
                                        )}{' '}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className='text-nowrap'>
                                        {' '}
                                        اپلکیشن فعال ؟
                                      </td>
                                      <td>
                                        {dataFech.appActive ? (
                                          <i className='fa fa-check'></i>
                                        ) : (
                                          <i className='fa fa-times'></i>
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className='text-nowrap'>
                                        {' '}
                                        مشکل انضباطی دارد ؟
                                      </td>
                                      <td>
                                        {dataFech.hasDiscipline ? (
                                          <i className='fa fa-check'></i>
                                        ) : (
                                          <i className='fa fa-times'></i>
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className='text-nowrap'>
                                        {' '}
                                        نیرو فعال است ؟
                                      </td>
                                      <td>
                                        {dataFech.isActive ? (
                                          <i className='fa fa-check'></i>
                                        ) : (
                                          <i className='fa fa-times'></i>
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className='text-nowrap'>
                                        {' '}
                                        نیرو آماده به کار است ؟
                                      </td>
                                      <td>
                                        {dataFech.isReady ? (
                                          <i className='fa fa-check'></i>
                                        ) : (
                                          <i className='fa fa-times'></i>
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className='text-nowrap'>
                                        {' '}
                                        نقطه سرویس پیشنهادی
                                      </td>
                                      <td>
                                        {dataFech.suggestedServicePoint ?? '-'}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className='text-nowrap'>
                                        {' '}
                                        انبار پیشنهادی
                                      </td>
                                      <td>
                                        {dataFech.suggestedWarehouse ?? '-'}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className='text-nowrap'>
                                        {' '}
                                        نیرو VIP است؟
                                      </td>
                                      <td>
                                        {dataFech.isVip ? (
                                          <i className='fa fa-check'></i>
                                        ) : (
                                          <i className='fa fa-times'></i>
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className='text-nowrap'>
                                        گروه اصلی خدمات
                                      </td>
                                      <td>{dataFech.categoryTite}</td>
                                    </tr>
                                    <tr>
                                      <td className='text-nowrap'>
                                        نوع خدمات نیرو{' '}
                                      </td>
                                      <td>
                                        <ul className='item-Type_of_power_service'>
                                          {dataFech.hasOwnProperty('groupNames')
                                            ? dataFech.groupNames.map(
                                                (item, index) => (
                                                  <li key={index}>{item}</li>
                                                )
                                              )
                                            : null}
                                        </ul>
                                      </td>
                                    </tr>
                                  </tbody>
                                </Table>
                              </div>
                            </Col>
                            <Col lg='6' md='6' sm='6' xs='12'>
                              <div
                                style={{
                                  border: '1px solid #e9e9e9',
                                  borderRadius: '10px',
                                }}
                              >
                                <TabelWrokDay userId={match.params.id} />
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              lg='12'
                              md='12'
                              sm='12'
                              xs='12'
                              className='mt-4'
                            >
                              <Accordion>
                                <Card>
                                  <Accordion.Toggle
                                    as={Card.Header}
                                    eventKey='0'
                                    onClick={() => handelAccordion(0)}
                                  >
                                    آدرس پیشفرض
                                  </Accordion.Toggle>
                                  <Accordion.Collapse eventKey='0'>
                                    <Card.Body>
                                      {idAccordion === 0 ? (
                                        <DefaultWorkerAddress data={dataFech} />
                                      ) : null}
                                    </Card.Body>
                                  </Accordion.Collapse>
                                </Card>
                                <Card>
                                  <Accordion.Toggle
                                    as={Card.Header}
                                    eventKey='1'
                                    onClick={() => handelAccordion(1)}
                                  >
                                    مدارک
                                  </Accordion.Toggle>
                                  <Accordion.Collapse eventKey='1'>
                                    <Card.Body>
                                      {idAccordion === 1 ? (
                                        <DocumentWorker />
                                      ) : null}
                                    </Card.Body>
                                  </Accordion.Collapse>
                                </Card>
                                <Card>
                                  <Accordion.Toggle
                                    as={Card.Header}
                                    eventKey='2'
                                    onClick={() => handelAccordion(2)}
                                  >
                                    مرخصی ها
                                  </Accordion.Toggle>
                                  <Accordion.Collapse eventKey='2'>
                                    <Card.Body>
                                      {idAccordion === 2 ? (
                                        <LevelWorker />
                                      ) : null}
                                    </Card.Body>
                                  </Accordion.Collapse>
                                </Card>
                              </Accordion>
                            </Col>
                          </Row>
                        </div>
                      ) : null}
                    </div>
                    <div
                      variant='success'
                      id='noanim-tab-example-tabpane-finance'
                      aria-labelledby='noanim-tab-example-tab-finance'
                      role='tabpanel'
                      aria-hidden='true'
                      className={
                        navitem === 'امور مالی' ? 'tab-pane active' : 'tab-pane'
                      }
                    >
                      {navitem === 'امور مالی' ? (
                        <FinanceWorker data={id} />
                      ) : null}
                    </div>
                    <div
                      variant='success'
                      id='noanim-tab-example-tabpane-order'
                      aria-labelledby='noanim-tab-example-tab-order'
                      role='tabpanel'
                      aria-hidden='true'
                      className={
                        navitem === 'کارهای نیرو'
                          ? 'tab-pane active'
                          : 'tab-pane'
                      }
                    >
                      {navitem === 'کارهای نیرو' ? (
                        <OrderWorker workerId={match.params.id} />
                      ) : null}
                    </div>
                    <div
                      variant='success'
                      id='noanim-tab-example-tabpane-jobDispatch'
                      aria-labelledby='noanim-tab-example-tab-jobDispatch'
                      role='tabpanel'
                      aria-hidden='true'
                      className={
                        navitem === 'پخش کار' ? 'tab-pane active' : 'tab-pane'
                      }
                    >
                      {navitem === 'پخش کار' ? (
                        <JobDispatchWorker workerId={match.params.id} />
                      ) : null}
                    </div>
                    <div
                      variant='success'
                      id='noanim-tab-example-tabpane-message'
                      aria-labelledby='noanim-tab-example-tab-message'
                      role='tabpanel'
                      aria-hidden='true'
                      className={
                        navitem === 'پیام‌ها' ? 'tab-pane active' : 'tab-pane'
                      }
                    >
                      {navitem === 'پیام‌ها' ? (
                        <WorkerMessages id={dataFech?.code} />
                      ) : null}
                    </div>
                    <div
                      variant='success'
                      id='noanim-tab-example-tabpane-blacklist'
                      aria-labelledby='noanim-tab-example-tab-blacklist'
                      role='tabpanel'
                      aria-hidden='true'
                      className={
                        navitem === 'لیست سیاه' ? 'tab-pane active' : 'tab-pane'
                      }
                    >
                      {navitem === 'لیست سیاه' ? (
                        <WorkerBlacklist id={match.params.id} />
                      ) : null}
                    </div>
                    <div
                      variant='success'
                      id='noanim-tab-example-tabpane-favlist'
                      aria-labelledby='noanim-tab-example-tab-favlist'
                      role='tabpanel'
                      aria-hidden='true'
                      className={
                        navitem === 'مورد علاقه'
                          ? 'tab-pane active'
                          : 'tab-pane'
                      }
                    >
                      {navitem === 'مورد علاقه' ? (
                        <WorkerFavlist id={match.params.id} />
                      ) : null}
                    </div>
                    <div
                      variant='success'
                      id='noanim-tab-example-tabpane-intro'
                      aria-labelledby='noanim-tab-example-tab-intro'
                      role='tabpanel'
                      aria-hidden='true'
                      className={
                        navitem === 'معرف‌ها' ? 'tab-pane active' : 'tab-pane'
                      }
                    >
                      {navitem === 'معرف‌ها' ? <Introducers /> : null}
                    </div>
                    <div
                      variant='success'
                      id='noanim-tab-example-tabpane-survey'
                      aria-labelledby='noanim-tab-example-tab-survey'
                      role='tabpanel'
                      aria-hidden='true'
                      className={
                        navitem === 'نظرسنجی' ? 'tab-pane active' : 'tab-pane'
                      }
                    >
                      {navitem === 'نظرسنجی' ? <SurveyWorker /> : null}
                    </div>
                    <div
                      variant='success'
                      id='noanim-tab-example-tabpane-ticket'
                      aria-labelledby='noanim-tab-example-tab-ticket'
                      role='tabpanel'
                      aria-hidden='true'
                      className={
                        navitem === 'تیکتها' ? 'tab-pane active' : 'tab-pane'
                      }
                    >
                      {navitem === 'تیکتها' ? (
                        <ExpertTicket id={match?.params?.id} />
                      ) : null}
                    </div>
                  </div>
                </Col>
              </Row>
            ) : null}
          </section>
        </Layout>
      ) : (
        <Redirect to={{ pathname: '/login', state: { status: 302 } }} />
      )}
    </>
  );
};
export default WorkerId;
